import VConsole from 'vconsole'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'

// 全环境注入 vConsole 以便排查线上白屏
if (import.meta.env.MODE === 'production' || import.meta.env.MODE === 'development') {
  new VConsole()
}

// 捕获未处理的异步错误，防止静默崩溃
window.addEventListener('unhandledrejection', (event) => {
  console.error('捕获到未处理的异步错误:', event.reason)
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
